<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <!-- <div class="d-flex flex-column">
                <div class="text-right mb-3"></div>
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div> -->

            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table sa-card-border">
                        <template #cell(index)="row">
                            <span> {{ row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(createDate)="{ item }">
                            <span>{{ formatDateTime(item.createDate) }}</span>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    components: {},
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            btnNuovaAccettazioneHidden: false,
            pathResource: "/progettocuorerichieste",
            linkedit: "/rsaaccettazione",
            pathResourceRicoveraPaziente: "/rsaaccettazioni/aggiornastato",
            pathResourceAnnullaAccettazione: "/rsaaccettazioni/aggiornastato",
            filtroProgettoCuore: {},
            items: [],
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Identificativo",
                    key: "identificativo",
                },
                {
                    label: "Codice Icd IX",
                    key: "codiceIcdix",
                },
                {
                    label: "Descrizione Icd IX",
                    key: "descrizioneIcdix",
                },
                {
                    label: "Data Ora",
                    key: "createDate",
                    sortable: true,
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroProgettoCuore"]) {
                me.filtroProgettoCuore = JSON.parse(sessionStorage["filtroProgettoCuore"]);
            }

            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroProgettoCuore.page = me.currentPage;
            me.filtroProgettoCuore.forPage = me.perPage;
            me.$emit("beforeLoadData");
            axios
                .get(link, { params: me.filtroProgettoCuore })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onClickView(item) {
            let me = this;
            me.$router.push("/rsaaccettazione/view/" + item.id);
        },
        onClickRicovera(item) {
            let me = this;
            me.$refs.cmpAccettazionePostiLettoModalEdit.show(item);
        },
        onClickProva(item) {
            let me = this;
            me.ricovera(item);
        },
        ricovera(item) {
            let accettazioneStato = { idAccetazione: item.id, stato: "RICOVERATO" };
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRicoveraPaziente;
            axios
                .post(link, JSON.stringify(accettazioneStato))
                .then(() => {
                    me.loadData();
                })
                .catch((error) => {
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        annullaAccettazione(id) {
            let me = this;
            let accettazioneStato = {
                idAccetazione: id,
                stato: "CANCELLATO",
            };
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAnnullaAccettazione; /* + "/" + item.id */
            axios
                .post(link, JSON.stringify(accettazioneStato))
                .then(() => {
                    me.loadData();
                    me.$bvToast.toast("Cancellazione avvenuta con successo", {
                        title: "Successo",
                        variant: "success",
                        solid: true,
                    });
                })
                .catch((e) => {
                    console.log(e);
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore durante la cancellazione", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        onClickAnnullaAccetazione(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Cancella accettazione",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.annullaAccettazione(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
        },
        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
        },
    },
};
</script>
<style></style>
